import {
  Trees, Key, Gem, Droplet, Coins, Feather, Compass, Shell, Leaf, Hourglass, Sparkles, CircleDot,
  Search, Box, Bone, Bell, Triangle, Network, FileText, Star, Flower2, Sprout, Bug, Fish, Bird,
  Apple, Cherry, Carrot, Egg, Mountain, Sun, Moon, Flame, Snowflake, Wind, Hammer, Scissors, Watch,
  Lightbulb, Book, Anchor, Crown, Heart, Skull, Eye, Hand, Footprints, Glasses, Brush, Palette,
  Music, Camera, Coffee, Wine, FlaskConical, Microscope, Dna, Atom, Magnet, Battery, Puzzle, Dice5,
  Umbrella, Rocket, Shirt, Gift, Pencil, Map, Mail, Lock, Cookie, Rabbit, Cat, Snail, Turtle,
  Squirrel, Worm, Shrub, TreePine, Cloud, Waves, Zap, Telescope, Pipette, TestTube, Hexagon,
  Diamond, Shovel, Axe, Wand, Ghost, Ruler, Scroll, Bean, Wheat, Grape, Clover, Bubbles, Biohazard,
  Fingerprint, Clock, Headphones, Radio,
} from "lucide-react";

export const ICONS = {
  Trees, Key, Gem, Droplet, Coins, Feather, Compass, Shell, Leaf, Hourglass, Sparkles, CircleDot,
  Search, Box, Bone, Bell, Triangle, Network, FileText, Star, Flower2, Sprout, Bug, Fish, Bird,
  Apple, Cherry, Carrot, Egg, Mountain, Sun, Moon, Flame, Snowflake, Wind, Hammer, Scissors, Watch,
  Lightbulb, Book, Anchor, Crown, Heart, Skull, Eye, Hand, Footprints, Glasses, Brush, Palette,
  Music, Camera, Coffee, Wine, FlaskConical, Microscope, Dna, Atom, Magnet, Battery, Puzzle, Dice5,
  Umbrella, Rocket, Shirt, Gift, Pencil, Map, Mail, Lock, Cookie, Rabbit, Cat, Snail, Turtle,
  Squirrel, Worm, Shrub, TreePine, Cloud, Waves, Zap, Telescope, Pipette, TestTube, Hexagon,
  Diamond, Shovel, Axe, Wand, Ghost, Ruler, Scroll, Bean, Wheat, Grape, Clover, Bubbles, Biohazard,
  Fingerprint, Clock, Headphones, Radio,
};

export const ICON_NAMES = Object.keys(ICONS);

export const SpecimenIcon = ({ name, ...props }) => {
  const Icon = ICONS[name] || Sprout;
  return <Icon {...props} />;
};
